export default __webpack_public_path__ + "59b7946393fea1ef9cd29b62ec66b6e6.svg";